import React, { FC } from 'react';
import { View, Text, TextInput } from 'react-native';
import i18n from 'i18n-js';

import TouchableElement from '@components/common/touchableElement';
import Svg from '@styles/icons/svg';
import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import { MAX_NOTE_LENGTH } from '@v2/components/FinishJobModal/constants';
import type { NoteSectionProps } from '@v2/components/FinishJobModal/types';

const NoteSection: FC<NoteSectionProps> = ({
  editorMode,
  plainNoteContent,
  handlePlainNoteChange,
  openRteModal,
  scale = initialScale,
  font = initialFont,
  C,
}) => {
  const showCounter = editorMode === 'simple' && plainNoteContent.length > 1000;

  return (
    <View style={{ paddingHorizontal: scale(24) }}>
      <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: scale(12) }}>
        <Text style={[font['Headline'], { color: C('Label/Light/Primary') }]}>
          {i18n.t('Add Note (Optional)')}
        </Text>

        {editorMode === 'simple' && (
          <TouchableElement onPress={openRteModal}>
            {({ boxStyle, pressHoverColor }) => (
              <View
                style={[
                  boxStyle,
                  {
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: scale(4),
                    paddingVertical: scale(4),
                    paddingHorizontal: scale(8),
                    borderRadius: scale(6),
                    backgroundColor: C(pressHoverColor('Background/Light/Tertiary')),
                  },
                ]}
              >
                <Svg icon="rteText" width={scale(14)} height={scale(14)} color="Link/Light/Primary" />
                <Text style={[font['Footnote'], { color: C('Link/Light/Primary') }]}>{i18n.t('Switch to Rich Text Editor')}</Text>
              </View>
            )}
          </TouchableElement>
        )}
      </View>

      {editorMode === 'simple' ? (
        <>
          {showCounter && (
            <Text style={[font['Caption 1'], { color: C('Label/Light/Secondary'), textAlign: 'right', marginBottom: scale(4) }]}>
              {plainNoteContent.length}/{MAX_NOTE_LENGTH}
            </Text>
          )}
          <TextInput
            value={plainNoteContent}
            onChangeText={(text) => handlePlainNoteChange(text.slice(0, MAX_NOTE_LENGTH))}
            placeholder={i18n.t('Add any notes about this job...')}
            placeholderTextColor={C('Label/Light/Tertiary')}
            multiline
            maxLength={MAX_NOTE_LENGTH}
            style={[
              font['Body'],
              {
                color: C('Label/Light/Primary'),
                backgroundColor: C('Overlay/Light/Dim light'),
                borderWidth: scale(1),
                borderColor: C('Hairline/Light/No trans [mobile]'),
                borderRadius: scale(12),
                padding: scale(12),
                minHeight: scale(80),
                textAlignVertical: 'top',
              },
            ]}
          />
        </>
      ) : (
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            backgroundColor: C('Background/Light/Field on Panel [mobile]'),
            borderRadius: scale(12),
            padding: scale(12),
            gap: scale(8),
          }}
        >
          <Svg icon="rteText" width={scale(16)} height={scale(16)} color="Label/Light/Secondary" />
          <Text style={[font['Body'], { color: C('Label/Light/Primary'), flex: 1 }]}>{i18n.t('Rich text note added')}</Text>
          <TouchableElement onPress={openRteModal}>
            {({ boxStyle }) => (
              <View style={boxStyle}>
                <Text style={[font['Body'], { color: C('Link/Light/Primary') }]}>{i18n.t('Edit')}</Text>
              </View>
            )}
          </TouchableElement>
        </View>
      )}

    </View>
  );
};

export default NoteSection;
